export function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


export function getBrowserCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
  return null;
}

export const getPidFromUrl = (url) => {
  let pidN = "";
  try {
    const parsedUrl = new URL(url || window.location.href); 
    const pidnew = parsedUrl.searchParams.get("pid");
    pidN = pidnew ? `${pidnew}` : "";
  } catch (error) {
    console.error("Error getting 'pid' from URL:", error);
  }
  return pidN;
};